<template>
  <div>
    <div class="query_wapper">
      <div class="query_item">
        <el-button
          :loading="btnLoading"
          style="width:90px;padding:12px 0;text-align:center"
          type="primary"
          @click="batchPass"
        >批量通过</el-button>
      </div>
      <div class="query_item">
        <el-button type="warning" style="width:90px" @click="print">打印</el-button>
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="success" @click="exportExcel">导出</el-button>
      </div>
      <div class="query_item" v-if="type === 2">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按学校名称查看"
          v-model="query.schoolId"
          clearable
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.type !== 3">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按注册项目查看"
          clearable
          v-model="query.project"
        >
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按性别查看"
          clearable
          v-model="query.gender"
        >
          <el-option label="全部" value="all"></el-option>
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item" style="margin-right:0" v-if="userInfo.type == 1">
        <el-button style="width:90px" type="danger" @click="deletes">删除</el-button>
      </div>
    </div>
    <printTable ref="print_table" :printColumns="printColumns" :printTableData="printTableData"></printTable>
    <el-table
      ref="table"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      border
      style="width:100%;margin-top:20px"
      :data="tableData"
    >
      <el-table-column type="selection" :reserve-selection="true" align="center" width="60"></el-table-column>
      <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" width="160"></el-table-column>
      <el-table-column prop="gender" align="center" label="性别" width="80">
        <template slot-scope="{row}">
          <span>{{!row.gender?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="type === 2" prop="schoolName" align="center" label="就读学校" width="200">
        <template slot-scope="{row}">
          <span>{{row.schoolName}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="type === 2" align="center" label="入学时间">
        <template slot-scope="{row}">
          <span>{{row.startSchoolDateText}}</span>
        </template>
      </el-table-column>
      <template v-else>
        <el-table-column label="学校名称" align="center" prop="schoolName" width="200"></el-table-column>
        <el-table-column align="center" label="职称" width="150">
          <template slot-scope="{row}">
            <span>{{getPositional(row.positional)}}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column prop="registerNumber" align="center" label="注册号"></el-table-column>
      <el-table-column prop="sportsLevel" v-if="type === 2" align="center" label="入学性质">
        <template slot-scope="{row}">
          <span>{{row.sportsLevel === 1?'普通生':row.sportsLevel === 2?'体育生':'高水平'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="注册项目" width="110">
        <template slot-scope="{row}">
          <span>{{registProject(row.projectFirst)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" align="center" label="联系电话" width="115"></el-table-column>
      <el-table-column prop="state" align="center" label="状态" width="100">
        <template slot-scope="scope">
          <span
            :style="{color:screenStatus(scope.row.state).color}"
          >{{screenStatus(scope.row.state).label}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="lookRegistration(row.id,'watch')">查看</el-button>
          <!-- <el-button type="text" size="small" @click="operation(row.id,'pass')">通过</el-button>
          <el-button type="text" size="small" @click="openRejectModal(row.id)">驳回</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:40px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeDialog"
      :close-on-click-modal="false"
      top="50px"
      :visible.sync="centerDialogVisible"
      title="查看注册信息"
      width="1200px"
    >
      <updateRegistrationPage
        v-if="type === 2"
        @clearUpdate="clearUpdate"
        @examineSubmit="examineSubmit"
        :updateObj="updateObj"
      ></updateRegistrationPage>
      <coachUpdateRegistrationPage
        v-else
        @clearUpdate="clearUpdate"
        :updateObj="updateObj"
        @examineSubmit="examineSubmit"
      ></coachUpdateRegistrationPage>
    </el-dialog>
    <el-dialog
      width="700px"
      title="驳回理由"
      :visible.sync="rejectVisible"
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeRejectDialog"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="reason"
        resize="none"
        height="450px"
        maxlength="200"
        show-word-limit
        :autosize="{ minRows: 8, maxRows: 15}"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submitLoading"
          style="width:90px;margin-right:40px"
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      center
      :close-on-click-modal="false"
      title="删除"
      width="600px"
      :visible.sync="deleteModal"
    >
      <p style="font-size:18px;text-align:center;padding:20px">删除之后数据将不可恢复，是否继续？</p>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:90px;margin-right:40px" type="primary" @click="handleDelete">确 定</el-button>
        <el-button style="width:90px;" @click="deleteModal = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import printTable from "@/components/print-table";
import { getCoachList, coachSocietyAudit, deleteCoach } from "@/api/coach.js";
import {
  getAthleteList,
  societyAudit,
  getSchool,
  schoolAudit,
  deleteAthlete
} from "@/api/athletes.js";
import coachUpdateRegistrationPage from "../coach/component/update-registration-page";
import updateRegistrationPage from "../athletes/components/update-registration-page";
import registerData from "@/assets/json/register.json";
import {
  table,
  page,
  message,
  btn,
  formatPrintTableData,
  dialog
} from "@/common/js/mixins";
import { getSession } from "@/utils/storage";
import { baseUrl } from "@/utils/config.js";
export default {
  components: {
    updateRegistrationPage,
    coachUpdateRegistrationPage,
    printTable
  },
  mixins: [table, page, message, btn, formatPrintTableData, dialog],
  data() {
    return {
      reason: "",
      submitLoading: false,
      rejectVisible: false,
      rejectId: "",
      query: {
        project: "",
        keyword: "",
        gender: "",
        schoolId: "",
        state: 1
      },
      centerDialogVisible: false,
      userInfo: JSON.parse(getSession("userInfo")) || null,
      schoolList: [],
      type: null,
      updateObj: {
        type: "",
        id: ""
      },
      // 表格多选数据
      multipleList: [],
      stateList: [
        {
          label: "草稿",
          value: 0,
          color: "rgb(64, 142, 232)"
        },
        {
          label: "学校待审核",
          value: 1,
          color: "rgb(64, 142, 232)"
        },
        { label: "学校未通过", value: 2, color: "rgb(252, 91, 91)" },
        { label: "分会待审核", value: 3, color: "rgb(64, 142, 232)" },
        { label: "分会未通过", value: 4, color: "rgb(252, 91, 91)" },
        { label: "分会通过", value: 5, color: "rgb(51, 204, 154)" }
      ]
    };
  },
  computed: {
    projectList() {
      return [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
    },
    // 职称筛选
    getPositional() {
      return data => {
        let str = "";
        switch (data) {
          case 1: {
            str = "初级职称";
            break;
          }
          case 2: {
            str = "中级职称";
            break;
          }
          case 3: {
            str = "副教授（高级教练）";
            break;
          }
          case 4: {
            str = "教授（国家级教练）";
            break;
          }
        }
        return str;
      };
    },
    // 筛选状态
    screenStatus() {
      return data => {
        let status = {};
        this.stateList.filter(item => {
          if (data === item.value) status = item;
        });
        return status;
      };
    },
    // 筛选注册项目
    registProject() {
      return data => {
        let label = "";
        this.projectList.filter(item => {
          if (item.value === data) label = item.label;
        });
        return label;
      };
    },
    // 表格打印表头
    printColumns() {
      let column = [
        {
          title: "序号",
          key: "index",
          width: 55
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "性别",
          key: "genderText",
          width: 55
        }
      ];
      if (this.type === 2) {
        column.push(
          {
            title: "就读学校",
            key: "schoolName"
          },
          {
            title: "入学时间",
            key: "startSchoolDateText"
          },
          {
            title: "注册号",
            key: "registerNumber"
          },
          {
            title: "入学性质",
            key: "sportsLevel"
          }
        );
      } else {
        column.push(
          {
            title: "学校名称",
            key: "schoolName"
          },
          {
            title: "职称",
            key: "positionalText"
          },
          {
            title: "注册号",
            key: "registerNumber"
          }
        );
      }
      column.push(
        {
          title: "注册项目",
          key: "projectFirst"
        },
        {
          title: "联系电话",
          key: "phone",
          width: 110
        },
        {
          title: "状态",
          key: "state"
        }
      );
      return column;
    }
  },
  methods: {
    // 打印
    async print() {
      if (this.type === 1) {
        let { list } = await getCoachList({
          ...this.query,
          gender: this.query.gender === "all" ? "" : this.query.gender,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        });
        // 调用公共方法打印（方法在mixins.js)
        this.getPrintData(list);
      } else {
        let { list } = await getAthleteList({
          ...this.query,
          gender: this.query.gender === "all" ? "" : this.query.gender,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        });
        // 调用公共方法打印（方法在mixins.js)
        this.getPrintData(list);
      }
    },
    // 打开删除弹窗
    deletes() {
      if (this.multipleList.length == 0)
        return this.openWarn("请至少选择一条数据进行操作！");
      this.openDeleteDialog();
    },
    // 删除
    handleDelete() {
      let ids = this.multipleList
        .map(item => {
          return item.id;
        })
        .join(",");
      let currentPage =
        this.tableData.length === this.multipleList.length
          ? this.pageNo === 1
            ? this.pageNo
            : this.pageNo - 1
          : this.pageNo;
      if (this.type == 1) {
        deleteCoach({
          ids
        })
          .then(res => {
            this.openSuccess("删除成功！");
            this.closeDeleteDialog();
            this.getList(this.type, currentPage);
            this.$refs.table.clearSelection();
          })
          .catch(err => {});
      } else {
        deleteAthlete({
          ids
        })
          .then(res => {
            this.openSuccess("删除成功！");
            this.closeDeleteDialog();
            this.getList(this.type, currentPage);
            this.$refs.table.clearSelection();
          })
          .catch(err => {});
      }
    },
    // 驳回提交
    handleSubmit() {
      this.operation(this.rejectId, "reject");
    },
    // 驳回关闭
    handleCancel() {
      this.rejectVisible = false;
    },
    // 打开驳回弹窗
    openRejectModal(id) {
      this.rejectVisible = true;
      this.rejectId = id;
    },
    // 关闭驳回弹窗
    closeRejectDialog() {
      this.reason = "";
    },
    // 获取学校名称
    getSchoolList() {
      getSchool({})
        .then(res => {
          this.schoolList = res;
        })
        .catch(err => {});
    },
    // 关闭弹窗
    closeDialog() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
    }, // 查看/编辑页面返回
    clearUpdate() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.centerDialogVisible = false;
    },
    // 审核提交成功
    examineSubmit() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.centerDialogVisible = false;
      this.getList();
    },
    // 导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }

      let url =
        baseUrl +
        (this.type === 1 ? "/coach/downloadList?" : "/athlete/downloadList?");

      window.location.href = url + params.join("&");
    },
    // 查看注册信息
    lookRegistration(id, type) {
      Object.assign(this.updateObj, {
        id,
        type
      });
      this.centerDialogVisible = true;
    },
    // 通过/驳回
    operation(id, type) {
      if (this.type === 1) {
        coachSocietyAudit({
          ids: id,
          reason: this.reason,
          state: type === "pass" ? 5 : 4
        })
          .then(res => {
            this.rejectVisible = false;
            this.openSuccess("操作成功!");
            this.getList();
          })
          .catch(err => {
            this.rejectVisible = false;
          });
      } else {
        if (this.userInfo.type === 2) {
          schoolAudit({
            ids: id,
            reason: this.reason,
            state: type === "pass" ? 3 : 2
          })
            .then(res => {
              this.rejectVisible = false;
              this.openSuccess("操作成功!");
              this.getList();
            })
            .catch(err => {
              this.rejectVisible = false;
            });
        } else {
          societyAudit({
            ids: id,
            reason: this.reason,
            state: type === "pass" ? 5 : 4
          })
            .then(res => {
              this.rejectVisible = false;
              this.openSuccess("操作成功!");
              this.getList();
            })
            .catch(err => {
              this.rejectVisible = false;
            });
        }
      }
    },
    // 批量通过
    batchPass() {
      if (this.multipleList.length == 0)
        return this.openWarn("请至少选择一条数据进行操作！");
      this.openBtn();
      let ids = this.multipleList
        .map(item => {
          return item.id;
        })
        .join(",");
      if (this.type === 1) {
        coachSocietyAudit({
          ids,
          state: 5
        })
          .then(res => {
            this.openSuccess("操作成功!");
            this.getList();
            this.closeBtn();
          })
          .catch(err => {
            this.closeBtn();
          });
      } else {
        if (this.userInfo.type === 2) {
          schoolAudit({
            ids,
            state: 3
          })
            .then(res => {
              this.openSuccess("操作成功!");
              this.getList();
              this.closeBtn();
            })
            .catch(err => {
              this.closeBtn();
            });
        } else {
          societyAudit({
            state: 5,
            ids
          })
            .then(res => {
              this.openSuccess("操作成功！");
              this.getList();
              this.closeBtn();
            })
            .catch(err => {
              this.closeBtn();
            });
        }
      }
    },
    // 表格多选数据
    handleSelectionChange(val) {
      this.multipleList = val;
    },
    // 根据当前为运动员或教练员请求接口
    getList(type = this.type,currentPage = this.pageNo) {
      if (type === 1) {
        getCoachList({
          ...this.query,
          gender: this.query.gender === "all" ? "" : this.query.gender,
          pageNo: currentPage,
          pageSize: this.pageSize
        })
          .then(res => {
            this.total = res.total;
            this.tableData = res.list;
          })
          .catch(err => {});
      } else {
        getAthleteList({
          ...this.query,
          gender: this.query.gender === "all" ? "" : this.query.gender,
          pageNo: currentPage,
          pageSize: this.pageSize
        })
          .then(res => {
            this.total = res.total;
            this.tableData = [...res.list];
          })
          .catch(err => {});
      }
    },
    // 指定一个key标识这一行的数据
    getRowKey(row) {
      return row.id;
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    }
  },
  mounted() {
    let { currentRole } = JSON.parse(getSession("userInfo")) || "";
    this.type = currentRole;
    this.getSchoolList();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
</style>